import momentTZ from 'moment-timezone'
import { dispatch } from 'store'
import { DEFAULT_TIME_ZONE } from 'cf-models-restaurant/src/plugin/timezone'

// Resolve on every call so changing the selected location changes the clock.
export const moment = (...args) => momentTZ.tz(...args, dispatch.restaurant.getTimeZone())
export const orderMoment = (value, order) => momentTZ(value).tz(dispatch.restaurant.getOrderTimeZone(order))
// Organization-wide reports use an explicit Vancouver reporting calendar.
export const reportingMoment = (...args) => momentTZ.tz(...args, DEFAULT_TIME_ZONE)
